var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCommission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 3.3335C10.7997 3.3335 3.33301 10.8002 3.33301 20.0002C3.33301 29.2002 10.7997 36.6668 19.9997 36.6668C29.1997 36.6668 36.6663 29.2002 36.6663 20.0002C36.6663 10.8002 29.1997 3.3335 19.9997 3.3335ZM14.5497 12.7668C15.8997 12.7668 17.0163 13.8668 17.0163 15.2335C17.0163 16.5835 15.9163 17.7002 14.5497 17.7002C13.1997 17.7002 12.083 16.6002 12.083 15.2335C12.083 13.8668 13.183 12.7668 14.5497 12.7668ZM14.7497 26.3335C14.4997 26.5835 14.183 26.7002 13.8663 26.7002C13.5497 26.7002 13.233 26.5835 12.983 26.3335C12.4997 25.8502 12.4997 25.0502 12.983 24.5668L23.8997 13.6502C24.383 13.1668 25.183 13.1668 25.6663 13.6502C26.1497 14.1335 26.1497 14.9335 25.6663 15.4168L14.7497 26.3335ZM25.4497 27.2335C24.0997 27.2335 22.983 26.1335 22.983 24.7668C22.983 23.4168 24.083 22.3002 25.4497 22.3002C26.7997 22.3002 27.9163 23.4002 27.9163 24.7668C27.9163 26.1335 26.8163 27.2335 25.4497 27.2335Z",
    fill: "#4343D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCommission);
export default __webpack_public_path__ + "static/media/user_commission.906820bbb878ffab2c7e49d664e2610e.svg";
export { ForwardRef as ReactComponent };